import {
  getRetryAfter,
  isTimeoutError,
  type MerrInit,
  // TInit,
  // TRequest,
  // TResponse,
  // TRetry,
  // TError,
} from '@setplex/merr'
import type { RequestPolicy } from './request'
import type { RetryPolicy } from './retry'
import { FATAL_ERRORS } from './index.h'
import { HTTP_LATENCY, HTTP_TIMEOUT } from '../index.h'
// import { logger } from './lib'

export function createHooks(
  requestPolicy: RequestPolicy,
  _retryPolicy: RetryPolicy
): MerrInit['hooks'] {
  return {
    /**
     * Handle any Request from Merr
     * This also includes requests, triggered under the hood by Retry Policy
     */
    request(request) {
      // biome-ignore format: nah
      // logger.log('🟡', request.__?.timings?.map((t) => { switch (true) {
      //   case t instanceof TInit: return `init/${t}`
      //   case t instanceof TRequest: return `request/${t}`
      //   case t instanceof TResponse: return `response/${t}`
      //   case t instanceof TRetry: return `retry/${t}`
      //   case t instanceof TError: return `error/${t}`
      //   default: return `unknown/${t}`
      // }}))

      // check if request is allowed by Request Policy
      const trial = requestPolicy.trial(request, HTTP_TIMEOUT, HTTP_LATENCY)
      return trial
    },

    /**
     * Handle any result from Merr request processing
     */
    response(request, response, error) {
      // if there is no request - do nothing
      // this can happen if Merr fails to construct Request, so no request was actually made
      if (!request) return

      // biome-ignore format: nah
      // logger.log('🔵', request.__?.timings?.map((t) => { switch (true) {
      //   case t instanceof TInit: return `init/${t}`
      //   case t instanceof TRequest: return `request/${t}`
      //   case t instanceof TResponse: return `response/${t}`
      //   case t instanceof TRetry: return `retry/${t}`
      //   case t instanceof TError: return `error/${t}`
      //   default: return `unknown/${t}`
      // }}))

      // should Request Policy consider this case as failed or successful?
      // https://setplexapps.atlassian.net/wiki/spaces/MW/pages/3430776834/Request+Policy#Failure-Conditions
      if (response) {
        // this is successful request for Request Policy
        if (response.ok || !FATAL_ERRORS.includes(response.status)) {
          return requestPolicy.success(request)
        }
      }

      // do nothing if there is no response and error is not timeout error
      else if (!isTimeoutError(error)) return

      // handle failed response with Request Policy
      requestPolicy.failure(request, getRetryAfter(response))
    },
  }
}
